<template>
  <div class="login">
    <div class="box" style="margin: auto; max-width: 500px">
      <h3 class="title" v-if="!$ajax.getUser().valueOf()">Login</h3>
      <h3 class="title" v-else>Autenticato</h3>
      <form v-on:submit="formSubmit" method="POST">
        <fieldset
          :disabled="$ajax.anyLoading"
          v-if="!$ajax.getUser().valueOf()"
        >
          <div class="field">
            <div class="control">
              <input
                class="input"
                type="email"
                v-model.lazy.trim="login.email"
                placeholder="Email"
                autofocus
                required
              />
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input
                class="input"
                type="password"
                v-model.lazy.trim="login.password"
                placeholder="Password"
                required
              />
            </div>
          </div>
          <!--
                <div class="field">
                  <label class="checkbox">
                    <input type="checkbox">
                    Remember me
                  </label>
                </div>
          -->
          <button
            type="submit"
            class="button is-block is-info is-fullwidth"
            :class="{ 'is-loading': $ajax.anyLoading }"
          >
            Login
          </button>
          <!--<div class="has-text-grey has-text-right is-size-7">
            <a href="../">Password dimenticata?</a>
          </div>
          -->
        </fieldset>
        <div class="has-text-left" v-if="$ajax.getUser().valueOf()">
          <div>Bentornato {{ $ajax.getUser().name }}!</div>
          <div>
            <i>{{ $ajax.getUser().email }}</i>
            [{{ $ajax.getObject("roles", $ajax.getUser().roleId).name }}]
          </div>
          <div class="content">
            <ul>
              <!--
              <li>
                <router-link :to="`/user/${$ajax.getUser().id}`">Modifica profilo</router-link>
              </li>
              -->
              <li>
                <router-link to="cards">Crea scheda</router-link>
              </li>
            </ul>
          </div>

          <div class="has-text-grey has-text-right">
            <a
              class="button is-danger is-small is-outlined"
              v-on:click="$ajax.doLogout()"
              >LOGOUT</a
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      login: { email: null, password: null },
    };
  },
  methods: {
    formSubmit: function (e) {
      e.preventDefault();

      this.$ajax.request({
        address: "/login",
        data: this.login,
        onSuccess: (response) => {
          this.$ajax.setObject("productsUm", response.data.productsUm);
          this.$ajax.setObject("roles", response.data.roles);
          this.$ajax.setObject("regions", response.data.regions);
          this.$ajax.setObject(
            "servicesTipology",
            response.data.servicesTipology
          );

          this.$ajax.setToken(response.data.token);
          this.$ajax.setUser(response.data.user);
        },
      });
    },
  },
};
</script>

<!--
<style>
.box {
  width: 100%;
  height: 100%;
  background: red;
  /* perspective function in transform property */
  transform: perspective(800px) rotateY(-20deg) rotateX(5deg);
}
</style>
-->